import { Link, useNavigate } from "react-router-dom"
import { loadAuthDraft } from "../lib/authDraft"

const DISPLAY = "'Tilda Sans', sans-serif"
const BODY = "'Manrope', sans-serif"

function LegalBackLink() {
    const navigate = useNavigate()
    const draft = loadAuthDraft()

    if (!draft?.stack?.length) return null

    const handleBack = () => {
        navigate("/auth", {
            state: draft.modalBackground ? { backgroundLocation: draft.modalBackground } : undefined,
        })
    }

    return (
        <button
            type="button"
            onClick={handleBack}
            className="mb-6 inline-flex items-center gap-2 text-[14px] text-[#349be6] transition-colors hover:text-white"
            style={{ fontFamily: BODY }}>
            ← Назад к регистрации
        </button>
    )
}

export function LegalDocument({ title, children }: { title: string; children: React.ReactNode }) {
    return (
        <article className="mx-auto w-full max-w-3xl px-4 py-8 pb-28 md:px-6 md:pb-12 lg:max-w-4xl">
            <LegalBackLink />
            <h1
                className="mb-8 text-white"
                style={{ fontFamily: DISPLAY, fontWeight: 800, fontSize: "clamp(24px, 4vw, 36px)", letterSpacing: "-0.02em" }}>
                {title}
            </h1>
            <div className="flex flex-col gap-8">{children}</div>
        </article>
    )
}

export function LegalSection({ title, children, id }: { title: string; children: React.ReactNode; id?: string }) {
    return (
        <section id={id} className="flex flex-col gap-3 scroll-mt-20">
            <h2 className="text-white text-[17px] font-bold" style={{ fontFamily: DISPLAY, letterSpacing: "-0.01em" }}>
                {title}
            </h2>
            <div className="flex flex-col gap-3 text-[14px] leading-relaxed text-white/65" style={{ fontFamily: BODY }}>
                {children}
            </div>
        </section>
    )
}

export function LegalP({ children }: { children: React.ReactNode }) {
    return <p>{children}</p>
}

export function LegalUl({ items }: { items: React.ReactNode[] }) {
    return (
        <ul className="list-disc space-y-2 pl-5">
            {items.map((item, i) => (
                <li key={i}>{item}</li>
            ))}
        </ul>
    )
}

export function LegalLink({ to, href, children }: { to?: string; href?: string; children: React.ReactNode }) {
    const className = "text-[#349be6] underline underline-offset-2 transition-colors hover:text-white"

    if (to) {
        return (
            <Link to={to} className={className}>
                {children}
            </Link>
        )
    }
    return (
        <a href={href} target="_blank" rel="noreferrer" className={className}>
            {children}
        </a>
    )
}
